import type { AddressDetailsResponse } from './dto-client'

export interface AddressData {
    postZipCodebookId?: number
    settlementCodebookId?: number
    streetCodebookId?: number
    street?: string
    houseNumber?: string
    floor?: string
    apartment?: string
    entrance?: string
    blockNumber?: string
}

/**
 * Maps AddressDetailsResponse to the normalized AddressData, renaming
 * `apartmentNumber` to `apartment`. Replaces the former AddressData class.
 */
export const toAddressData = (data: AddressDetailsResponse): AddressData => ({
    postZipCodebookId: data.postZipCodebookId,
    settlementCodebookId: data.settlementCodebookId,
    streetCodebookId: data.streetCodebookId,
    street: data.street,
    houseNumber: data.houseNumber,
    floor: data.floor,
    apartment: data.apartmentNumber,
    entrance: data.entrance,
    blockNumber: data.blockNumber,
})
